import Cookies from "js-cookie";

const TokenKey = "User-Token";
const SimpleUserInfo = "User-Info";

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function getSimpleUserInfo() {
  return window.localStorage.getItem(SimpleUserInfo);
}

export function setSimpleUserInfo(userInfo) {
  return window.localStorage.setItem(SimpleUserInfo, JSON.stringify(userInfo));
}

export function removeSimpleUserInfo() {
  return window.localStorage.setItem(SimpleUserInfo, "");
}
